// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab__CgLST","active":"active__-S7cI"};